import { useState, useEffect } from 'react';
import { useLang } from '../context/LanguageContext';
import { isNativeApp } from '../utils/platform.js';
import { useWhatsAppHelp } from '../context/WhatsAppHelpContext';
import { useHelpGuide } from '../context/HelpGuideContext';
import { useNativeTab } from '../mobile/NativeTabContext';
import { hapticSelection } from '../utils/haptics';
import './BottomNav.css';

const ICONS = {
  home: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" aria-hidden>
      <path d="M3.6 10.8L12 3.6l8.4 7.2V20a1.2 1.2 0 0 1-1.2 1.2h-5.2v-6.2H9.8V21.2H4.8A1.2 1.2 0 0 1 3.6 20V10.8z" />
    </svg>
  ),
  homeOn: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M12 2.8L2.8 10.7V20.2c0 .9.7 1.6 1.6 1.6h5.4v-6.6h4.4v6.6h5.4c.9 0 1.6-.7 1.6-1.6V10.7L12 2.8z" />
    </svg>
  ),
  paper: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" aria-hidden>
      <path d="M7 4.2h8.2L20 9v11.2H7A2.2 2.2 0 0 1 4.8 18V6.4A2.2 2.2 0 0 1 7 4.2z" />
      <path d="M15.2 4.2V9H20M9 12.2h7M9 15.6h5" />
    </svg>
  ),
  paperOn: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M7 3.5h8.4L21 9.2v11.3c0 .8-.7 1.5-1.5 1.5H7A3 3 0 0 1 4 19V6.5A3 3 0 0 1 7 3.5zm8.2 1.4V9h4.2l-4.2-4.1z" />
    </svg>
  ),
  stories: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" aria-hidden>
      <rect x="3.5" y="5.5" width="17" height="13" rx="2.4" />
      <path d="M10 9.4v5.2l5-2.6-5-2.6z" fill="currentColor" stroke="none" />
    </svg>
  ),
  storiesOn: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M5.4 4.8h13.2A3.2 3.2 0 0 1 21.8 8v8a3.2 3.2 0 0 1-3.2 3.2H5.4A3.2 3.2 0 0 1 2.2 16V8A3.2 3.2 0 0 1 5.4 4.8zM10 9.2v5.7l5.4-2.85L10 9.2z" />
    </svg>
  ),
  you: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" aria-hidden>
      <circle cx="12" cy="8" r="3.3" />
      <path d="M5.2 19.4c1.2-3.1 3.6-4.7 6.8-4.7s5.6 1.6 6.8 4.7" />
    </svg>
  ),
  youOn: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <circle cx="12" cy="8" r="3.6" />
      <path d="M4.6 20.2c1.4-3.6 4.1-5.5 7.4-5.5s6 1.9 7.4 5.5H4.6z" />
    </svg>
  ),
  help: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden>
      <circle cx="12" cy="12" r="10" />
      <path d="M9.09 9a3 3 0 1 1 5.82 1c0 2-3 2-3 4" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ),
  wa: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
      <path d="M12 0C5.373 0 0 5.373 0 12c0 2.625.846 5.059 2.284 7.034L.789 23.492a.75.75 0 0 0 .914.914l4.458-1.495A11.95 11.95 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.75a9.72 9.72 0 0 1-4.95-1.35l-.355-.21-3.28 1.1 1.1-3.19-.23-.37A9.75 9.75 0 1 1 12 21.75z" />
    </svg>
  ),
};

const WEB_NAV = [
  { id: 'top', href: '#top', labelKey: 0, home: true, icon: ICONS.home },
  { id: 'paper', href: '#paper', labelKey: 1, primary: true, icon: ICONS.paper },
];

const ALL_SECTION_IDS = ['top', 'paper', 'archive', 'poll'];

function NativeBottomNav() {
  const { t } = useLang();
  const { tab, setTab } = useNativeTab();
  const items = [
    { id: 'home', label: t.nav?.[0] || 'Home', icon: ICONS.home, iconOn: ICONS.homeOn },
    { id: 'paper', label: t.navEpaper, icon: ICONS.paper, iconOn: ICONS.paperOn },
    { id: 'stories', label: t.navVideos, icon: ICONS.stories, iconOn: ICONS.storiesOn },
    { id: 'you', label: t.navMenu, icon: ICONS.you, iconOn: ICONS.youOn },
  ];

  return (
    <nav className="bottom-nav" aria-label="Main" data-sub-free>
      <div className="bottom-nav__bar">
        {items.map((item) => {
          const on = tab === item.id;
          return (
            <button
              key={item.id}
              type="button"
              className={`bottom-nav__item${on ? ' is-active' : ''}`}
              aria-current={on ? 'page' : undefined}
              onClick={() => {
                void hapticSelection();
                setTab(item.id);
              }}
            >
              <span className={`bottom-nav__pill${on ? ' is-on' : ''}`}>
                <span key={`${item.id}-${on ? 'on' : 'off'}`} className="bottom-nav__icon">
                  {on ? item.iconOn : item.icon}
                </span>
                <span className="bottom-nav__label">{item.label}</span>
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}

function WebBottomNav() {
  const { t } = useLang();
  const { openWhatsAppHelp } = useWhatsAppHelp();
  const { openHelpGuide } = useHelpGuide();
  const [activeId, setActiveId] = useState('top');

  useEffect(() => {
    const sections = ALL_SECTION_IDS.map((id) => document.getElementById(id)).filter(Boolean);
    if (!sections.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.intersectionRatio > 0)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio);
        if (visible[0]?.target?.id) setActiveId(visible[0].target.id);
      },
      { rootMargin: '-45% 0px -40% 0px', threshold: [0.08, 0.2, 0.4] }
    );

    sections.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const scrollToSection = (e, id) => {
    const target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    const header = document.getElementById('site-header');
    const offset = header?.offsetHeight ?? 0;
    const top = target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior: 'smooth' });
    setActiveId(id);
  };

  return (
    <nav className="bottom-nav" aria-label="Main" data-sub-free>
      <div className="bottom-nav__bar">
        {WEB_NAV.map((item) => (
          <a
            key={item.id}
            href={item.href}
            className={[
              'bottom-nav__item',
              item.primary ? 'bottom-nav__item--primary' : '',
              item.home ? 'bottom-nav__item--home' : '',
              activeId === item.id ? 'is-active' : '',
            ]
              .filter(Boolean)
              .join(' ')}
            aria-current={activeId === item.id ? 'page' : undefined}
            onClick={(e) => scrollToSection(e, item.id)}
          >
            <span className="bottom-nav__icon">{item.icon}</span>
            <span className="bottom-nav__label">{t.nav[item.labelKey]}</span>
          </a>
        ))}

        <button
          type="button"
          className="bottom-nav__item bottom-nav__item--help"
          onClick={openHelpGuide}
          aria-label={t.navHelp}
          title={t.helpGuideTitle}
        >
          <span className="bottom-nav__icon" aria-hidden>
            {ICONS.help}
          </span>
          <span className="bottom-nav__label">{t.navHelp}</span>
        </button>

        <button
          type="button"
          className="bottom-nav__item"
          onClick={() => openWhatsAppHelp('mobile_bar')}
          aria-label={t.navWhatsApp}
          title={t.navWhatsApp}
        >
          <span className="bottom-nav__icon" aria-hidden>
            {ICONS.wa}
          </span>
          <span className="bottom-nav__label">{t.navWhatsApp}</span>
        </button>
      </div>
    </nav>
  );
}

export default function BottomNav() {
  if (isNativeApp()) return <NativeBottomNav />;
  return <WebBottomNav />;
}
